import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["scroller"]

    navigate(event) {
        event.preventDefault()

        const id = decodeURIComponent((event.currentTarget.hash || "").replace(/^#/, ""))
        if (!id || !this.hasScrollerTarget) return

        const target = this.scrollerTarget.querySelector(`#${this.escapeSelector(id)}`)

        if (target) {
            const scrollerTop = this.scrollerTarget.getBoundingClientRect().top
            const targetTop = target.getBoundingClientRect().top
            const offset = targetTop - scrollerTop + this.scrollerTarget.scrollTop - 12

            this.scrollerTarget.scrollTo({top: Math.max(offset, 0), behavior: "smooth"})
        } else {
            this.scrollerTarget.scrollTo({top: 0, behavior: "smooth"})
        }

        this.activateLink(event.currentTarget)
    }

    activateLink(activeLink) {
        this.element.querySelectorAll("[data-story-about-nav-link]").forEach((link) => {
            link.classList.remove("bg-white", "text-indigo-700")
            link.removeAttribute("aria-current")
        })

        activeLink.classList.add("bg-white", "text-indigo-700")
        activeLink.setAttribute("aria-current", "true")
    }

    escapeSelector(value) {
        if (window.CSS && CSS.escape) return CSS.escape(value)

        return value.replace(/([ !"#$%&'()*+,./:;<=>?@[\\\]^`{|}~])/g, "\\$1")
    }
}
